'use client';


import { theme } from "../../theme/index.js";
import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay } from "@chakra-ui/react";
import { c } from "react-compiler-runtime";
import React from "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/AlertModal/AlertModal.tsx
const Overlay = (props) => {
	const $ = c(2);
	let t0;
	if ($[0] !== props) {
		t0 = /* @__PURE__ */ jsx(AlertDialogOverlay, { ...props });
		$[0] = props;
		$[1] = t0;
	} else t0 = $[1];
	return t0;
};
const Header = (props) => {
	const $ = c(2);
	let t0;
	if ($[0] !== props) {
		t0 = /* @__PURE__ */ jsx(AlertDialogHeader, {
			fontSize: theme.fontSizes.h7,
			...props
		});
		$[0] = props;
		$[1] = t0;
	} else t0 = $[1];
	return t0;
};
const CloseButton = (props) => {
	const $ = c(2);
	let t0;
	if ($[0] !== props) {
		t0 = /* @__PURE__ */ jsx(AlertDialogCloseButton, { ...props });
		$[0] = props;
		$[1] = t0;
	} else t0 = $[1];
	return t0;
};
const Close = (props) => {
	const $ = c(2);
	let t0;
	if ($[0] !== props) {
		t0 = /* @__PURE__ */ jsx(CloseButton, { ...props });
		$[0] = props;
		$[1] = t0;
	} else t0 = $[1];
	return t0;
};
const Content = (t0) => {
	const $ = c(6);
	let children;
	let props;
	if ($[0] !== t0) {
		({children, ...props} = t0);
		$[0] = t0;
		$[1] = children;
		$[2] = props;
	} else {
		children = $[1];
		props = $[2];
	}
	let t1;
	if ($[3] !== children || $[4] !== props) {
		t1 = /* @__PURE__ */ jsx(AlertDialogContent, {
			...props,
			children
		});
		$[3] = children;
		$[4] = props;
		$[5] = t1;
	} else t1 = $[5];
	return t1;
};
const Body = (props) => {
	const $ = c(2);
	let t0;
	if ($[0] !== props) {
		t0 = /* @__PURE__ */ jsx(AlertDialogBody, {
			my: 4,
			py: 0,
			border: 0,
			...props
		});
		$[0] = props;
		$[1] = t0;
	} else t0 = $[1];
	return t0;
};
const Footer = (props) => {
	const $ = c(2);
	let t0;
	if ($[0] !== props) {
		t0 = /* @__PURE__ */ jsx(AlertDialogFooter, { ...props });
		$[0] = props;
		$[1] = t0;
	} else t0 = $[1];
	return t0;
};
const AlertModal = (t0) => {
	const $ = c(7);
	let children;
	let props;
	if ($[0] !== t0) {
		({children, ...props} = t0);
		$[0] = t0;
		$[1] = children;
		$[2] = props;
	} else {
		children = $[1];
		props = $[2];
	}
	let t1;
	if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = /* @__PURE__ */ jsx(Overlay, {});
		$[3] = t1;
	} else t1 = $[3];
	let t2;
	if ($[4] !== children || $[5] !== props) {
		t2 = /* @__PURE__ */ jsxs(AlertDialog, {
			scrollBehavior: "inside",
			isCentered: true,
			motionPreset: "scale",
			...props,
			children: [t1, children]
		});
		$[4] = children;
		$[5] = props;
		$[6] = t2;
	} else t2 = $[6];
	return t2;
};
AlertModal.Header = Header;
AlertModal.Content = Content;
AlertModal.Close = Close;
AlertModal.Body = Body;
AlertModal.Footer = Footer;

//#endregion
export { AlertModal };
//# sourceMappingURL=AlertModal.js.map